import RiyadhShowroomBanner from "../assets/images/riyadh-showroom.jpg";

const LOCATIONS = [
  {
    id: "riyadh-showroom-1",
    type: "showroom",
    city: "Riyadh",
    isDefault: true,
    banner: RiyadhShowroomBanner,
    fridayAvailable: false,
    branchNameKey: "locationPage.branches.riyadh-showroom-1.branchName",
    addressTextKey: "locationPage.branches.riyadh-showroom-1.addressText",
    workingDaysKey: "locationPage.branches.riyadh-showroom-1.workingDays",
    workingTimeKey: "locationPage.branches.riyadh-showroom-1.workingTime",
    contacts: ["8001240664"],
    emails: ["info@btatc.com"],
    mapLink: "https://maps.app.goo.gl/nFcCguNArbaEVaST8?g_st=iw",
    mapEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3281.864978891304!2d46.798778899999995!3d24.6381961!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f0729f48095f1%3A0xea5a4a23b7659451!2zTEFOREtJTkcgfCDZhNin2YbYr9mD2YbYrA!5e1!3m2!1sen!2ssa!4v1771249656339!5m2!1sen!2ssa",
  },
  {
    id: "riyadh-service-1",
    type: "service",
    city: "Riyadh",
    isDefault: true,
    fridayAvailable: true,
    branchNameKey: "locationPage.branches.riyadh-service-1.branchName",
    addressTextKey: "locationPage.branches.riyadh-service-1.addressText",
    contacts: ["011-4256557", "053-5067078"],
    emails: ["FR2@FUCHS.COM.SA"],
    mapLink: "https://goo.gl/maps/GxHRfY8XXeq",
    mapEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3283.648625899599!2d46.6665498002994!3d24.570213325568865!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f10202358a537%3A0xdf97d67d6c98800d!2sFuchs%20One%20Stop%20Al%20Suwaidi!5e1!3m2!1sen!2ssa!4v1772615971368!5m2!1sen!2ssa",
  },
  {
    id: "riyadh-service-2",
    type: "service",
    city: "Riyadh",
    isDefault: false,
    fridayAvailable: false,
    branchNameKey: "locationPage.branches.riyadh-service-2.branchName",
    addressTextKey: "locationPage.branches.riyadh-service-2.addressText",
    contacts: ["059-4396635"],
    emails: ["FR27@FUCHS.COM.SA"],
    mapLink: "https://maps.app.goo.gl/5vRwJsmtWeoVCXNLA",
    mapEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d877.5717330280029!2d46.86738895101853!3d24.54787480882297!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2fa196429d78e5%3A0xfc6f6112acf71b7c!2sFuchs%20One%20Stop%202Nd%20Industrial%20Area!5e1!3m2!1sen!2ssa!4v1772616224144!5m2!1sen!2ssa",
  },
  {
    id: "dammam-service-1",
    type: "service",
    city: "Dammam",
    isDefault: false,
    fridayAvailable: true,
    branchNameKey: "locationPage.branches.dammam-service-1.branchName",
    addressTextKey: "locationPage.branches.dammam-service-1.addressText",
    contacts: ["058-3340189"],
    emails: ["FD3@FUCHS.COM.SA"],
    mapLink: "https://maps.app.goo.gl/5vRwJsmtWeoVCXNLA",
    mapEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1616.7473728265613!2d50.08582391508435!3d26.41934542457861!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e49fc8e1e62635b%3A0x8ef9da91fabdfbc9!2sFuchs%20One%20Stop!5e1!3m2!1sen!2ssa!4v1772620712644!5m2!1sen!2ssa",
  },
  {
    id: "jeddah-service-1",
    type: "service",
    city: "Jeddah",
    isDefault: false,
    fridayAvailable: true,
    branchNameKey: "locationPage.branches.jeddah-service-1.branchName",
    addressTextKey: "locationPage.branches.jeddah-service-1.addressText",
    contacts: ["059-8597408"],
    emails: ["FJ13@FUCHS.COM.SA"],
    mapLink: "https://goo.gl/maps/yyXMNJANvw42",
    mapEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1676.67810155223!2d39.1183358!3d21.7578324!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c1630236dff215%3A0xcac6e01c93d06cac!2sFuchs%20One%20Stop%20Obhour!5e1!3m2!1sen!2ssa!4v1772618411730!5m2!1sen!2ssa",
  },
  {
    id: "jeddah-service-2",
    type: "service",
    city: "Jeddah",
    isDefault: false,
    fridayAvailable: false,
    branchNameKey: "locationPage.branches.jeddah-service-2.branchName",
    addressTextKey: "locationPage.branches.jeddah-service-2.addressText",
    contacts: ["054-2870067", "050-9599104"],
    emails: ["FJ21@FUCHS.COM.SA"],
    mapLink: "https://maps.app.goo.gl/eEFEN2cEvSunVvaf8",
    mapEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d233.33373894576866!2d39.25121549083948!3d21.42939854447394!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c3cbee48481259%3A0xe1c2b63a8f0ce33e!2sFuchs%20One%20Stop%20Al%20Haraj!5e1!3m2!1sen!2ssa!4v1772618611892!5m2!1sen!2ssa",
  },
  {
    id: "makkah-service-1",
    type: "service",
    city: "Makkah",
    isDefault: false,
    fridayAvailable: true,
    branchNameKey: "locationPage.branches.makkah-service-2.branchName",
    addressTextKey: "locationPage.branches.makkah-service-2.addressText",
    contacts: ["053-8025917", "059-9463354"],
    emails: ["FM3@FUCHS.COM.SA"],
    mapLink: "https://maps.app.goo.gl/tGMbkGjUA4Scrvbj8",
    mapEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d210.11969650334197!2d39.796576945785716!3d21.38844118529821!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c21be918a23f07%3A0xbc71cde32b7edf3a!2zRlVDSFMgT05FU1RPUCDZgdmI2YPYsyDZiNmGINiz2KrZiNio!5e1!3m2!1sen!2ssa!4v1772618773266!5m2!1sen!2ssa",
  },
  {
    id: "rabigh-service-1",
    type: "service",
    city: "Rabigh",
    isDefault: false,
    fridayAvailable: false,
    branchNameKey: "locationPage.branches.rabigh-service-1.branchName",
    addressTextKey: "locationPage.branches.rabigh-service-1.addressText",
    contacts: ["058-3663948", "058-0860262"],
    emails: ["FRBG1@FUCHS.COM.SA"],
    mapLink: "https://goo.gl/maps/uuoegmoPzcG2",
    mapEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1664.7979389425486!2d39.037312383768906!3d22.753383392551836!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c094485cae5b15%3A0x4ceafe87f06e96e8!2sFuchs%20One%20Stop%20Al%20Joud!5e1!3m2!1sen!2ssa!4v1772618976490!5m2!1sen!2ssa",
  },
  {
    id: "madinah-service-1",
    type: "service",
    city: "Madinah",
    isDefault: false,
    fridayAvailable: true,
    branchNameKey: "locationPage.branches.madinah-service-1.branchName",
    addressTextKey: "locationPage.branches.madinah-service-1.addressText",
    contacts: ["056-9437061"],
    emails: ["FMD4@FUCHS.COM.SA"],
    mapLink: "https://goo.gl/maps/uktrCfi1QyWPFUQR6",
    mapEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d228.1074780783279!2d39.62366506478214!3d24.492067480510283!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjTCsDI5JzMxLjUiTiAzOcKwMzcnMjUuOSJF!5e1!3m2!1sen!2ssa!4v1772619232093!5m2!1sen!2ssa",
  },
  {
    id: "yanbu-service-1",
    type: "service",
    city: "Yanbu",
    isDefault: false,
    fridayAvailable: false,
    branchNameKey: "locationPage.branches.yanbu-service-1.branchName",
    addressTextKey: "locationPage.branches.yanbu-service-1.addressText",
    contacts: ["050-0601706"],
    emails: ["FY1@FUCHS.COM.SA"],
    mapLink: "https://goo.gl/maps/uktrCfi1QyWPFUQR6",
    mapEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1648.143668668211!2d38.0613792!3d24.0833402!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15b9060a61aa7b89%3A0x286f8fe8b194c96d!2sFuchs%20One%20Stop%20Al%20Khurik!5e1!3m2!1sen!2ssa!4v1772619394409!5m2!1sen!2ssa",
  },
  {
    id: "tabuk-service-1",
    type: "service",
    city: "Tabuk",
    isDefault: false,
    fridayAvailable: false,
    branchNameKey: "locationPage.branches.tabuk-service-1.branchName",
    addressTextKey: "locationPage.branches.tabuk-service-1.addressText",
    contacts: ["059-7163599"],
    emails: ["FT1@FUCHS.COM.SA"],
    mapLink: "https://goo.gl/maps/uktrCfi1QyWPFUQR6",
    mapEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3176.3912153542424!2d36.567965900000004!3d28.388265999999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15a9ad0733da3eb5%3A0xa3365cf04d3716cb!2sFuchs%20One%20Stop%20Al%20Azizya!5e1!3m2!1sen!2ssa!4v1772619607126!5m2!1sen!2ssa",
  },
  {
    id: "sakaka-service-1",
    type: "service",
    city: "Sakaka",
    isDefault: false,
    fridayAvailable: false,
    branchNameKey: "locationPage.branches.sakaka-service-1.branchName",
    addressTextKey: "locationPage.branches.sakaka-service-1.addressText",
    contacts: ["058-1834037"],
    emails: ["FSK1@FUCHS.COM.SA"],
    mapLink: "https://maps.app.goo.gl/stP8LYCAavCvdgFU9",
    mapEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d217.15431474409542!2d40.18867294014847!3d29.966017558614045!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1572bb336480763b%3A0xbd8fc711cd3b0673!2sOne%20stop%20fuchs!5e1!3m2!1sen!2ssa!4v1772619730668!5m2!1sen!2ssa",
  },
  {
    id: "kahmis-mushait-service-1",
    type: "service",
    city: "Khamis Mushait",
    isDefault: false,
    fridayAvailable: true,
    branchNameKey: "locationPage.branches.kahmis-mushait-service-1.branchName",
    addressTextKey: "locationPage.branches.kahmis-mushait-service-1.addressText",
    contacts: ["058-0105749"],
    emails: ["FA5@FUCHS.COM.SA"],
    mapLink: "https://maps.app.goo.gl/xXcxK4GkfRnLpfsd6",
    mapEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d237.9863923234643!2d42.68790288192259!3d18.299191804414683!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15fb50aabb14cba1%3A0x36559018ec7b7ba3!2sFuchs%20One%20Stop%20Al%20Mazab!5e1!3m2!1sen!2ssa!4v1772619935775!5m2!1sen!2ssa",
  },
  {
    id: "bisha-service-1",
    type: "service",
    city: "Bisha",
    isDefault: false,
    fridayAvailable: true,
    branchNameKey: "locationPage.branches.bisha-service-1.branchName",
    addressTextKey: "locationPage.branches.bisha-service-1.addressText",
    contacts: ["059-0485894"],
    emails: ["FBS1@FUCHS.COM.SA"],
    mapLink: "https://goo.gl/maps/dzCQjeWe7aQ2",
    mapEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d942.1584824634714!2d42.61943612847446!3d20.004009598832724!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15f02957900bb893%3A0x63e8976185bf6a1f!2sFuchs%20One%20Stop%20Alkhozama!5e1!3m2!1sen!2ssa!4v1772620065506!5m2!1sen!2ssa",
  },
  {
    id: "Jizan-service-1",
    type: "service",
    city: "Jizan",
    isDefault: false,
    fridayAvailable: false,
    branchNameKey: "locationPage.branches.Jizan-service-1.branchName",
    addressTextKey: "locationPage.branches.Jizan-service-1.addressText",
    contacts: ["058-0814334"],
    emails: ["FJZ2@FUCHS.COM.SA"],
    mapLink: "https://maps.app.goo.gl/ScRkCn6gB4PcRmGe6",
    mapEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d239.4801207011364!2d42.64558927731002!3d17.178544144899654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15fd512bffe86785%3A0xa9ba48aec8caadc5!2sFuchs%20One%20Stop%20Sabya!5e1!3m2!1sen!2ssa!4v1772620205329!5m2!1sen!2ssa",
  },
  {
    id: "Al-Baha-service-1",
    type: "service",
    city: "Al Baha",
    isDefault: false,
    fridayAvailable: false,
    branchNameKey: "locationPage.branches.Al-Baha-service-1.branchName",
    addressTextKey: "locationPage.branches.Al-Baha-service-1.addressText",
    contacts: ["059-6782427"],
    emails: ["FAB3@FUCHS.COM.SA"],
    mapLink: "https://goo.gl/maps/jvhvFwexNU2Kb4mw9",
    mapEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d477.1523342385047!2d41.47673212961716!3d20.008191246025522!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjDCsDAwJzI5LjYiTiA0McKwMjgnMzcuOCJF!5e1!3m2!1sen!2ssa!4v1772620382824!5m2!1sen!2ssa",
  },
  {
    id: "Buraydah-service-1",
    type: "service",
    city: "Buraydah",
    isDefault: false,
    fridayAvailable: true,
    branchNameKey: "locationPage.branches.Buraydah-service-1.branchName",
    addressTextKey: "locationPage.branches.Buraydah-service-1.addressText",
    contacts: ["057-2585543"],
    emails: ["FB1@FUCHS.COM.SA"],
    mapLink: "https://maps.app.goo.gl/Y2Lfqz7k55R5977t7",
    mapEmbedUrl:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d202.19774025394463!2d43.96411631538177!3d26.35975401237346!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x157f5849b9570d39%3A0x178aba7e9adab5d!2sFuchs%20One%20Stop%20Al%20Safraa!5e1!3m2!1sen!2ssa!4v1772620558861!5m2!1sen!2ssa",
  },
];

export default LOCATIONS;